"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delta = void 0;
const tree_dump_1 = require("tree-dump");
const shared_1 = require("./codec/binary/shared");
const print_1 = require("../../util/print");
/**
 * Represents a *Delta Group* - a missing state fragment that can be applied to
 * a CRDT state of another peer to "fill in" the missing state.
 */
class Delta {
    static from(data) {
        return shared_1.decoder.decodeDelta(data);
    }
    constructor(
    /**
     * The *Version Vector* - causal context of the start of the delta. I.e. this
     * is time boundary what the other peer sends to us, this is what the other
     * peer has already incorporated into their state.
     */
    vv0, 
    /**
     * The *Version Vector* - causal context of the end of the delta. I.e. this
     * is what the delta incorporates up to. This is what peer 2 replies with.
     */
    vv1, 
    /**
     * A list of *Delta Mutators* (operations) in this *Delta Group*. MUST be
     * applied in order.
     */
    batch) {
        this.vv0 = vv0;
        this.vv1 = vv1;
        this.batch = batch;
        this.meta = void 0;
    }
    toBinary() {
        return shared_1.encoder.encodeDelta(this);
    }
    // ---------------------------------------------------------------- Printable
    /**
     * Returns a textual human-readable representation of the delta. This can be
     * used for debugging purposes.
     *
     * @param tab Start string for each line.
     * @returns Text representation of the delta.
     */
    toString(tab = '') {
        return ('Delta' +
            (0, tree_dump_1.printTree)(tab, [
                (tab) => 'meta' + (0, tree_dump_1.printTree)(tab, [(tab) => (0, print_1.indent)(tab, this.meta)]),
                (tab) => 'vv0: ' + this.vv0.toString(tab),
                (tab) => 'vv1: ' + this.vv1.toString(tab),
                (tab) => this.batch.toString(tab),
            ]));
    }
}
exports.Delta = Delta;
